export default "__VITE_ASSET__C53BdT5U__"